import React, { useEffect, useState } from 'react'
import {
  Spin,
  message,
  Form,
  Card,
  Button,
  DatePicker,
  Table,
  Anchor,
  Tooltip,
  Popover,
  Select,
  Input,
  Divider,
  Pagination
} from 'antd'
import FormItem from 'antd/lib/form/FormItem'
import { Link } from 'react-router-dom'
import classnames from 'classnames'
import styles from './complaint-information-inquiry.module.less'
import common from '@/public/common'
import { ajaxApi, fileDownloadApi, fileDownloadApiNew, format, downloadApi } from '@/server/index'
import moment from 'moment'
import 'moment/locale/zh-cn'
import { stringify } from 'qs'
import { outputMoney, outformat, getCookieNew, getCookie } from '@/public/utils'
import DateChoose from '@/compenents/dateChoose'
import _ from 'lodash'
moment.locale('zh-cn')

const NophysicalComplaintPrinting = (props) => {
  const [printData, setPrintData] = useState({
    'supplier_code': '1425',
    'refund_code': 'CT2012459210',
    'category_id': 1,
    'brand_id': 2,
    'begin_time': 156321031000,
    'end_time': 1576212021000,
    'product_code': '036254'
  })
  const [detailesData, setDetailesData] = useState([])

  // 获取打印信息
  const getPrintData = async (data) => {
    try {
      let res = await ajaxApi({
        // url: common.scpUrl + 'work-order/print-supplier-complaint',
        url: `${common.SapUrl}po-return/v2/query-complaint-detail/by-supplier`,
        params: {
          ...data,
          admin_id: getCookie('sid') || null,
          page_num: 1,
          page_size: 999999999
        }
      })
      if (res.data.code === '0') {
        let _data = res.data.data.data
        if (_data.length !== 0) {
          setDetailesData(_data)
        } else {
          setDetailesData([])
        }
      }
    } catch (e) {
      console.log(e)
    }
  }

  useEffect(() => {
    let _printData = JSON.parse(getCookieNew('printData'))
    if (_printData) {
      setPrintData(_printData)
      getPrintData(_printData)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  // 导出
  const handleExport = async () => {
    try {
      let res = await fileDownloadApiNew({
        // url: common.scpUrl + 'work-order/export-supplier-complaint',
        url: `${common.SapUrl}po-return/v2/export-complaint-detail/by-supplier`,
        param: {
          admin_id: getCookie('supplierinfo') ? JSON.parse(getCookie('supplierinfo')).user_id : null,
          ...printData,
        },
        filename: (printData.begin_time ? moment(printData.begin_time).format('YYYY-MM-DD') : '') + '-' + (printData.end_time ? moment(printData.end_time).format('YYYY-MM-DD') : '') + '投诉信息.xls'
      })
    } catch (e) {
      console.log(e)
    }
  }

  // 打印
  const handlePrint = (e) => {
    e.stopPropagation()
    var body = window.document.body.innerHTML
    window.document.body.innerHTML = document.getElementById('html_').innerHTML
    window.print()
    window.document.body.innerHTML = body
    window.location.reload()
  }

  const addM = (data) => {
    let phoneNum = data
    let phoneNum_ = phoneNum.substr(0, 3) + '****' + phoneNum.substr(7)
    return phoneNum_
  }

  return (
    <div style={{background: '#fff'}}>
      <div id='html_' style={{width: '98%', margin: '0 auto', marginTop: '4%', position: 'relative'}}>

        <h2 style={{textAlign: 'center'}}>客户投诉详情（无实物）</h2>
        <div className={styles.contents}>
          <table>
            <thead>
              <tr>
                <td >类别</td>
                <td >品牌</td>
                <td >商品编码</td>
                <td >货品编码</td>
                <td >货品名称</td>
                <td >镜片类型</td>
                <td >花色</td>
                <td >抛期</td>
                <td >基弧</td>
                <td >度数</td>
                <td >批次</td>
                <td >投诉数量（盒）</td>
                <td style={{width:'60px'}}>下单时间</td>
                <td style={{width:'60px'}}>投诉时间</td>
                <td >
                  <div>投诉原因一级/</div>
                  <div>投诉原因二级</div>
                </td>

                <td >消费者姓名</td>
                <td >消费者地址</td>
                <td >消费者电话</td>
                <td >销售渠道</td>
                <td style={{width:'60px'}}>创建时间</td>
              </tr>
            </thead>
            <tbody>

              {detailesData ? (
                detailesData.map((item, index) => {
                  return (
                    <tr>
                      <td >{_.get(item, 'category_name', '') ? _.get(item, 'category_name', '') : '-'}</td>
                      <td >{_.get(item, 'brand_name', '') ? _.get(item, 'brand_name', '') : '-'}</td>
                      <td >{_.get(item, 'item_code', '') ? _.get(item, 'item_code', '') : '-'}</td>
                      <td >{_.get(item, 'product_code', '') ? _.get(item, 'product_code', '') : '-'}</td>
                      <td >{_.get(item, 'product_name', '') ? _.get(item, 'product_name', '') : '-'}</td>
                      <td >{_.get(item, 'sub_category_name', '') ? _.get(item, 'sub_category_name', '') : '-'}</td>
                      <td >{_.get(item, 'color', '') ? _.get(item, 'color', '') : '-'}</td>
                      <td >{_.get(item, 'discard_cycle_name', '') ? _.get(item, 'discard_cycle_name', '') : '-'}</td>
                      <td >{_.get(item, 'contact_arc', '') ? _.get(item, 'contact_arc', '') : '-'}</td>
                      <td >{_.get(item, 'degree', '') ? _.get(item, 'degree', '') : '-'}</td>
                      <td >{_.get(item, 'batch_no', '') ? _.get(item, 'batch_no', '') : '-'}</td>
                      <td >{_.get(item, 'complaint_count', '') ? _.get(item, 'complaint_count', '') : '-'}</td>
                      <td  style={{width:'70px'}}>{_.get(item, 'order_time', '') && _.get(item, 'order_time', '') ? moment(_.get(item, 'order_time', '')).format('YYYY-MM-DD HH:mm:ss') : '-'}</td>
                      <td  style={{width:'70px'}}>{_.get(item, 'complaint_time', '') && _.get(item, 'complaint_time', '') ? moment(_.get(item, 'complaint_time', '')).format('YYYY-MM-DD HH:mm:ss') : '-'}</td>
                      <td >
                        <div>{_.get(item, 'complaint_reason_category', '') ? _.get(item, 'complaint_reason_category', '') : '-'}</div>
                        <div>{_.get(item, 'complaint_reason', '') ? _.get(item, 'complaint_reason', '') : '-'}</div>
                      </td>
                      <td >{_.get(item, 'customer_name', '') ? _.get(item, 'customer_name', '') : '-'}</td>
                      <td >{_.get(item, 'address', '') ? _.get(item, 'address', '') : '-'}</td>
                      <td >{_.get(item, 'customer_phone', '') ? addM(_.get(item, 'customer_phone', '')) : '-'}</td>
                      <td >{_.get(item, 'source_channel_name', '') ? _.get(item, 'source_channel_name', '') : '-'}</td>
                      <td  style={{width:'70px'}}>{_.get(item, 'add_time', '') && _.get(item, 'add_time', '') ? moment(_.get(item, 'add_time', '')).format('YYYY-MM-DD HH:mm:ss') : '-'}</td>
                    </tr>
                  )
                })

              ) : <tr>暂无数据</tr>}
            </tbody>
          </table>
        </div>
      </div>
      <div style={{marginTop: '16px', textAlign: 'center'}}>  <Button type='primary' style={{marginRight: '16px'}} onClick={handlePrint}>打印</Button>
        <Button type='primary' style={{marginRight: '16px'}} onClick={handleExport}>导出</Button>
      </div>
    </div>
  )
}
export default NophysicalComplaintPrinting



// WEBPACK FOOTER //
// ./src/pages/newcomplaintinformationinquiry/nophysical-complaint-printing.js